import { isMyload } from "../../utils/constants";
import { IONICWrapper } from "../../utils/common";

export const isContactUsVisible = (module: any): boolean =>
  !isMyload(module)
    ? IONICWrapper.details.keys &&
      IONICWrapper.details.keys.configuration.contactUsVisibility == true
    : true;
